import Vue from "vue";
import Vuex from "vuex";

// Importing Modules
import HomeData from "./modules/home";
import BlogData from "./modules/blog";
import WorkshopData from "./modules/workshop";

Vue.use(Vuex);

const state = {
  loading: 0,
  loaded: false
};

const getters = {
  loading(state) {
    return state.loading > 0;
  }
};
const mutations = {
  updateLoading(state, num) {
    state.loading += num;
  }
};
const actions = {
  ADD_LOADING({ commit }) {
    commit("updateLoading", 1);
  },
  REM_LOADING({ commit }) {
    commit("updateLoading", -1);
  }
};

const modules = {
  HomeData,
  BlogData,
  WorkshopData
};

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules
});

export default store;
